// extracted by mini-css-extract-plugin
module.exports = {"error":"topError_error__1ocmq"};